import { ChangeEvent } from 'react';
import styles from './SelectInput.module.scss';

interface IOptionValues {
    value: string;
    label: string;
}
interface ISelectInputProps {
    label: string;
    isValidField?: boolean;
    nameInput: string;
    selectedValue?: string;
    onSelectedChange: (e: ChangeEvent<HTMLSelectElement>) => void;
    optionValues: Array<IOptionValues>;
}
export default function SelectInput({
    label,
    isValidField = true,
    nameInput,
    selectedValue,
    onSelectedChange,
    optionValues,
}: ISelectInputProps) {
    return (
        <section className={`${styles.SelectInputContainer} ${!isValidField ? styles.error : ''} `}>
            <label>
                {label}
                <select name={nameInput} value={selectedValue} onChange={onSelectedChange}>
                    <option value="" label="Selecione uma opção" disabled></option>
                    {optionValues.map((option) => (
                        <option value={option.value}>{option.label}</option>
                    ))}
                </select>
            </label>
        </section>
    );
}
